import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import plusIcon from "../../assets/images/icons/plus_icon.svg";
import ClubbieButton from "../../components/ClubbieButton/ClubbieButton";
import ClubbieInput from "../../components/ClubbieInput/ClubbieInput";
import ClubbieModal from "../../components/Modal/ClubbieModal";
// TODO: Legacy file - needs full refactor to use categories instead of divisions/seasons
// import {
//   createDivision,
//   selectDivisionAction,
//   selectSeasonAction,
// } from "../../redux/slices/tournamentSlice";
import { DASHBOARD_STACK } from "../../utils/screenNames";
import "./CreateTournamentDivision.css";

const CreateTournamentDivision = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );
  const divisions = selectedTournament?.divisions || [];
  const [showAddNew, setShowAddNew] = useState(false);
  const [newDivisionName, setNewDivisionName] = useState("");
  const [numberOfTeams, setNumberOfTeams] = useState(0);
  const [seasons, setSeasons] = useState([{ name: "" }]);
  const [errors, setErrors] = useState({});

  const validateDivision = (name) => {
    if (!name.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        division: "Division name is required",
      }));
      return false;
    }
    if (
      divisions.some((div) => div.name.toLowerCase() === name.toLowerCase())
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        division: "Division name already exists",
      }));
      return false;
    }
    setErrors((prevErrors) => ({ ...prevErrors, division: "" }));
    return true;
  };

  const validateSeason = (name, index) => {
    if (!name.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`season${index}`]: "Season name is required",
      }));
      return false;
    }
    if (
      seasons.some(
        (season, i) =>
          i !== index && season.name.toLowerCase() === name.toLowerCase()
      )
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`season${index}`]: "Season name already exists",
      }));
      return false;
    }
    setErrors((prevErrors) => ({ ...prevErrors, [`season${index}`]: "" }));
    return true;
  };

  const handleAddDivision = async () => {
    try {
      if (!validateDivision(newDivisionName)) {
        return;
      }

      // Validate all seasons
      const seasonErrors = seasons.map((season, index) =>
        validateSeason(season.name, index)
      );
      if (seasonErrors.includes(false)) {
        return;
      }

      if (numberOfTeams <= 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          numberOfTeams: "Number of teams must be greater than 0",
        }));
        return;
      }

      const newDivision = {
        name: newDivisionName.trim(),
        numberOfTeams: numberOfTeams,
        season: seasons.map((season) => ({
          name: season.name.trim(),
          registrationFee: 0,
        })),
      };

      if (selectedTournament?.id) {
        // TODO: Legacy - createDivision thunk removed
        // const result = await dispatch(
        //   createDivision({
        //     tournamentId: selectedTournament.id,
        //     divisionData: newDivision,
        //   })
        // );
        //
        // if (result.meta.requestStatus === "fulfilled") {
        //   setNewDivisionName("");
        //   setNumberOfTeams(0);
        //   setSeasons([{ name: "" }]);
        //   setShowAddNew(false);
        //   toast.success("Division added successfully!");
        // } else {
        //   throw new Error("Failed to add division");
        // }
      }
    } catch (error) {
      toast.error(error.message || "Failed to add division");
    }
  };

  const handleSeasonClick = async (e, division, season) => {
    e.stopPropagation();
    // TODO: Legacy - selectDivisionAction and selectSeasonAction thunks removed
    // try {
    //   const resultDiv = await dispatch(
    //     selectDivisionAction({
    //       tournamentId: selectedTournament.id,
    //       divisionId: division._id,
    //     })
    //   );
    //
    //   if (resultDiv.meta.requestStatus === "fulfilled") {
    //     const resultSeason = await dispatch(
    //       selectSeasonAction({
    //         tournamentId: selectedTournament.id,
    //         divisionId: division._id,
    //         seasonId: season._id,
    //       })
    //     );
    //     if (resultSeason.meta.requestStatus === "fulfilled") {
    //       navigate(DASHBOARD_STACK.CREATE_TOURNAMENT.TEAM_REGISTRATION_FEE);
    //     }
    //   }
    // } catch (error) {
    //   toast.error(error.message || "Failed to select season");
    // }
  };

  const handleSkip = async () => {
    try {
      if (selectedTournament?.id) {
        if (divisions.length === 0) {
        }

        navigate(DASHBOARD_STACK.HOME);
      }
    } catch (error) {
      toast.error(error.message || "Failed to skip divisions");
    }
  };

  const renderContent = () => {
    if (divisions.length === 0) {
      return (
        <div className="empty-division-content">
          <button
            className="add-division-circle"
            onClick={() => setShowAddNew(true)}
          >
            <img src={plusIcon} alt="Add" className="plus-icon" />
          </button>
        </div>
      );
    }

    return (
      <div className="division-content">
        <button
          className="add-division-circle"
          onClick={() => setShowAddNew(true)}
        >
          <img src={plusIcon} alt="Add" className="plus-icon" />
        </button>

        <div className="divisions-list">
          {divisions.map((division, index) => (
            <div
              key={index}
              className={`division-item ${division.isSelected ? "selected" : ""}`}
            >
              <div className="division-info">
                <span className="division-name">{division.name}</span>
                <span className="teams-count">
                  {division.numberOfTeams} Teams
                </span>
              </div>
              {division.season?.map((season) => (
                <div
                  key={season.id}
                  className={`season-item ${division.isSelected && season.isSelected ? "selected" : ""}`}
                  onClick={(e) => handleSeasonClick(e, division, season)}
                >
                  {season.name}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="input-section">
      <p className="division-subtitle">Create Divisions for your Tournament</p>

      {renderContent()}

      <ClubbieModal
        isOpen={showAddNew}
        toggle={() => {
          setShowAddNew(false);
          setNewDivisionName("");
          setNumberOfTeams(0);
          setSeasons([{ name: "" }]);
          setErrors({});
        }}
        title="Add Division"
      >
        <div className="add-division-input">
          <label className="text-[#FEFCEB]">Enter Division Name</label>
          <ClubbieInput
            type="text"
            value={newDivisionName}
            onChange={(e) => setNewDivisionName(e.target.value)}
            placeholder="Enter division name"
            autoFocus
            className={errors.division ? "error my-3" : "my-3"}
          />
          {errors.division && (
            <div className="error-message">{errors.division}</div>
          )}

          <label className="text-[#FEFCEB]">Enter Number of Teams</label>
          <div className="teams-input-container">
            <ClubbieInput
              type="number"
              value={numberOfTeams.toString()}
              onChange={(e) => setNumberOfTeams(parseInt(e.target.value) || 0)}
              placeholder="Enter number of teams"
              min="1"
              className={errors.numberOfTeams ? "error my-3" : "my-3"}
            />
            {errors.numberOfTeams && (
              <div className="error-message">{errors.numberOfTeams}</div>
            )}
          </div>

          <div className="seasons-section">
            <label className="text-[#FEFCEB]">Enter Season Name</label>
            {seasons.map((season, index) => (
              <div key={index} className="season-input-container">
                <ClubbieInput
                  type="text"
                  value={season.name}
                  onChange={(e) => {
                    const newSeasons = [...seasons];
                    newSeasons[index].name = e.target.value;
                    setSeasons(newSeasons);
                  }}
                  placeholder={`Enter season ${index + 1} name`}
                  className={errors[`season${index}`] ? "error my-3" : "my-3"}
                />
                {errors[`season${index}`] && (
                  <div className="error-message">
                    {errors[`season${index}`]}
                  </div>
                )}
              </div>
            ))}
          </div>

          <span
            onClick={() => setSeasons([...seasons, { name: "" }])}
            className="text-[#FEFCEB] d-flex justify-content-end align-items-center my-3"
          >
            <img
              src={plusIcon}
              alt="Add Season"
              className="plus-icon-small mx-1"
            />
            Add More Season
          </span>

          <div className="add-division-actions">
            <ClubbieButton
              onClick={() => {
                setShowAddNew(false);
                setNewDivisionName("");
                setErrors({});
              }}
            >
              Cancel
            </ClubbieButton>
            <ClubbieButton onClick={handleAddDivision}>Add</ClubbieButton>
          </div>
        </div>
      </ClubbieModal>

      {!divisions.length && (
        <ClubbieButton className="skip-button" onClick={handleSkip}>
          Skip
        </ClubbieButton>
      )}
    </div>
  );
};

export default CreateTournamentDivision;
